export const copyToClipboard = async (textToCopy: string): Promise<boolean> => {
	if (navigator.clipboard && window.isSecureContext) {
		try {
			await navigator.clipboard.writeText(textToCopy);
			return true;
		} catch (error) {
			console.error(error);
			return false;
		}
	} else {
		const textArea = document.createElement('textarea');
		textArea.value = textToCopy;
		textArea.style.position = 'absolute';
		textArea.style.left = '-999999px';
		document.body.appendChild(textArea);
		textArea.focus();
		textArea.select();

		try {
			const successful = document.execCommand('copy');
			return successful;
		} catch (error) {
			console.error(error);
			return false;
		} finally {
			textArea.remove();
		}
	}
};
